/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EntityChangeType = {
    Created: 'Created',
    Updated: 'Updated',
    Deleted: 'Deleted'
} as const;
export type EntityChangeType = typeof EntityChangeType[keyof typeof EntityChangeType];


export function EntityChangeTypeFromJSON(json: any): EntityChangeType {
    return EntityChangeTypeFromJSONTyped(json, false);
}

export function EntityChangeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityChangeType {
    return json as EntityChangeType;
}

export function EntityChangeTypeToJSON(value?: EntityChangeType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the EntityChangeType interface.
 */
 export function instanceOfEntityChangeType(value: any): value is EntityChangeType {
    return Object.values(EntityChangeType).includes(value)
}

